// extracted by mini-css-extract-plugin
export var blockTitle = "speaker-module--block-title--bde9f";
export var col = "speaker-module--col--86d38";
export var row = "speaker-module--row--db262";
export var speaker = "speaker-module--speaker--eec4a";